import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../utils/style';

const Paragraph = styled.p`
  color: ${props =>
    props.light
      ? props.theme.gray
      : props.inverse ? props.theme.white : props.theme.black};
  font-size: ${props =>
    props.bigger ? '1.15rem' : props.big ? '1.075rem' : '.9rem'};
  line-height: 1.6;
  margin: 0 0 10px;

  ${media.tablet`
    font-size: ${props =>
      props.bigger ? '1.4rem' : props.big ? '1.2rem' : '.9rem'};
  `};
`;

let P = ({ children, ...otherProps }) => (
  <Paragraph {...otherProps}>{children}</Paragraph>
);

P.propTypes = {
  children: PropTypes.node.isRequired
};

export default P;



// WEBPACK FOOTER //
// ./src/components/P.js